import { Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { addClient, editClient, getClients, grantClientAccess, revokeClientAccess } from '../Services/PortfolioService';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Breadcrumbs from '../CommonElements/Breadcrumbs';
import Table from '../CustomComponent/Tables/Table';
import { TableColumn } from 'react-data-table-component';
import { Eye, Pencil, Unlock, Lock, Plus, Trash2, CheckCircle, XCircle } from 'lucide-react';
import { Btn } from '../AbstractElements';
import Modal from '../CustomComponent/Modals/Modal';
import SelectDropdown from '../CustomComponent/Form/SelectDropdown';
import { getCountries } from '../Services/LocationService';
import { useNavigate } from 'react-router-dom';
import ActionDropdown from '../CustomComponent/ActionDropdown';
type PropertyField = 'name' | 'address' | 'contact_name' | 'contact_email';

export default function Portfolio() {
    const navigate = useNavigate();
    const [clients, setClients] = useState<any>([]);
    const [countries, setCountries] = useState<any>([]);
    const [clientModalOpen, setClientModalOpen] = useState(false);
    const toggleClientModal = () => setClientModalOpen(!clientModalOpen);

    const [editClientModalOpen, setEditClientModalOpen] = useState(false);
    const toggleEditClientModal = () => setEditClientModalOpen(!editClientModalOpen);

    const [name, setName] = useState('');
    const [country, setCountry] = useState<string>('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [properties, setProperties] = useState([
        { name: '', address: '', contact_name: '', contact_email: '' }
    ]);

    const [clientId, setClientId] = useState('');
    const [editName, setEditName] = useState('');
    const [editCountry, setEditCountry] = useState<string>('');
    const [editEmail, setEditEmail] = useState('');
    const [editAddress, setEditAddress] = useState('');
    const [editProperties, setEditProperties] = useState([
        { name: '', address: '', contact_name: '', contact_email: '' }
    ]);

    const handlePropertyChange = (index: number, field: PropertyField, value: string) => {
        const updatedProperties = [...properties];
        updatedProperties[index][field] = value;
        setProperties(updatedProperties);
    };

    const removePropertyRow = (index: number) => {
        const updatedProperties = [...properties];
        updatedProperties.splice(index, 1);
        setProperties(updatedProperties);
    };

    const addPropertyRow = () => {
        setProperties([...properties, { name: '', address: '', contact_name: '', contact_email: '' }]);
    };

    const handleEditPropertyChange = (index: number, field: PropertyField, value: string) => {
        const updatedProperties = [...properties];
        updatedProperties[index][field] = value;
        setEditProperties(updatedProperties);
    };

    const removeEditPropertyRow = (index: number) => {
        const updatedProperties = [...editProperties];
        updatedProperties.splice(index, 1);
        setEditProperties(updatedProperties);
    };

    const addEditPropertyRow = () => {
        setEditProperties([...editProperties, { name: '', address: '', contact_name: '', contact_email: '' }]);
    };

    const handleAddClient = async () => {
        try {
            const data = {
                name,
                country,
                address,
                email_address: email,
                properties
            }

            const { message, data: clientData } = await addClient(data);
            toast.success(message || 'Client added successfully')
            fetchClients()
        } catch (error: any) {
            toast.error(error.message || "Failed to add client");
        }
        // Here you can process form inputs later
        toggleClientModal();
    };

    const handleEditClient = async () => {
        try {
            const data = {
                name: editName,
                country: editCountry,
                address: editAddress,
                email_address: editEmail,
                // properties: editProperties
            };

            const { status, message } = await editClient(clientId, data);
            toast.success(message || 'Client updated successfully')
            fetchClients()
        } catch (error: any) {
            toast.error(error.message || "Failed to update client");
        }
        // Here you can process form inputs later
        toggleEditClientModal();
    };

    const actions = [
        {
            label: 'View',
            icon: <Eye size={16} color="green" className="me-2" />,
            onClick: (row: any) => navigate(`${process.env.PUBLIC_URL}/clients/${row.client_id}`),
        },
        {
            label: 'Edit',
            icon: <Pencil size={16} color="orange" className="me-2" />,
            onClick: (row: any) => {
                setEditName(row.name)
                setEditEmail(row.email_address)
                setEditAddress(row.address)
                setEditCountry(row.country_id);
                // setEditProperties(row.properties)
                setClientId(row.client_id)
                toggleEditClientModal();
            },
        },
        {
            label: (row: any) => row.status == 'no access' ? 'Grant Access' : 'Revoke Access',
            // icon: (row: any) => row.status == 'no access' ? <Unlock size={16} color="green" className="me-2" /> : <Lock size={16} color="red" className="me-2" />,
            icon: (row: any) => row.status === 'no access' ? <CheckCircle size={16} className="text-success" /> : <XCircle size={16} className="text-danger" />,
            onClick: async (row: any) => {
                if (row.status === 'no access') {
                    try {
                        const { status, message } = await grantClientAccess(row.client_id);
                        toast.success(message || "Access granted successfully!");
                    } catch (error: any) {
                        toast.error(error.message || "Failed to grant access");
                    }
                } else {
                    try {
                        const { status, message } = await revokeClientAccess(row.client_id);
                        toast.success(message || "Access revoked successfully!");
                    } catch (error: any) {
                        toast.error(error.message || "Failed to grant access");
                    }
                }
            },

        },
    ];

    const tableColumns: TableColumn<any>[] = [
        {
            name: "S/N",
            cell: (_row, index) => index + 1,
            sortable: false,
            width: '70px',
        },
        {
            name: "Company Name",
            cell: (row: any) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }} onClick={() => navigate(`${process.env.PUBLIC_URL}/clients/${row.client_id}`)}>
                        <span className="text-primary" style={{ whiteSpace: 'nowrap' }}>{row.name || ''}</span>
                    </div>
                );
            },
            sortable: true,
            center: false,
            width: '250px',
            // color: 'orange'
        },
        {
            name: "Email-address",
            selector: (row) => row.email_address,
            sortable: false,
            center: false,
        },
        {
            name: "Country",
            cell: (row) => row.country.name,
            sortable: false,
            center: false,
        },
        {
            name: "Address",
            cell: (row) => row.address,
            sortable: false,
            center: false,
        },
        {
            name: "No of Properties",
            cell: (row) => row.properties_count,
            sortable: false,
            center: true,
            width: '130px',
        },
        {
            name: 'Actions',
            cell: (row) => (
                <div style={{ position: 'relative' }}>
                    <ActionDropdown
                        row={row}
                        actions={actions}
                    />
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '70px',
        },
    ];

    useEffect(() => {
        fetchClients();
        fetchCountries();
    }, []);

    const fetchClients = async () => {
        try {
            const clientsData = await getClients();
            setClients(clientsData);
        } catch (error: any) {
            toast.error(error?.message || "Failed to fetch clients");
        }
    };

    const fetchCountries = async () => {
        try {
            const countriesData = await getCountries();
            // console.log(countriesData.country_list)
            setCountries(countriesData.country_list)
        } catch (error: any) {
            toast.error(error?.message || "Failed to fetch countries");
        }
    };

    const countryOptions = countries.map((country: { id: string; name: string }) => ({
        value: country.id, // Assuming client_id is the unique identifier
        label: country.name // Assuming client_name is the display name
    }));

    const handleCountryChange = (selectedOption: any) => {
        setCountry(selectedOption as string)
        // setSelectedClient(selectedOption as string); // Update the selected client state
    };

    const handleEditCountryChange = (selectedOption: any) => {
        setEditCountry(selectedOption as string)
        // setSelectedClient(selectedOption as string); // Update the selected client state
    };

    return (
        <>
            <Breadcrumbs pageTitle='Portfolio' />
            <Container className='default-dashboard' fluid>
                <Row>
                    <Col sm="12" className="d-flex justify-content-end">
                        <Btn color='primary' className="mb-3" onClick={toggleClientModal}>Add Client</Btn>
                    </Col>

                    <Table title='Clients' tableColumns={tableColumns} data={clients} />
                </Row>
                <Modal isOpen={clientModalOpen} toggle={toggleClientModal} action={handleAddClient} title="Add New Client" button='Add' size='xl'>
                    <Form>
                        <Row>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for="companyName">Company Name</Label>
                                    <Input id="companyName" name="companyName" type="text" placeholder="Enter company name" onChange={(event) => setName(event.target.value)} />
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for="email">Email</Label>
                                    <Input id="email" name="email" type="email" placeholder="Enter email address" onChange={(event) => setEmail(event.target.value)} />
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <SelectDropdown title={'Country'} options={countryOptions} onOptionSelected={(val) => handleCountryChange(val)} />
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for="address">Address</Label>
                                    <Input id="address" name="address" type="text" placeholder="e.g. 5" onChange={(event) => setAddress(event.target.value)} />
                                </FormGroup>
                            </Col>
                            {/* <Col sm='4'></Col>
                            
                            <FormGroup>
                                <Label for="properties">Number of Properties</Label>
                                <Input id="properties" name="properties" type="number" placeholder="e.g. 5" />
                            </FormGroup> */}
                        </Row>
                        <Row style={{ marginTop: '5px' }}>
                            <Col sm='4'>Properties</Col>
                        </Row>
                        {properties.map((property, index) => (
                            <Row key={index} style={{ marginTop: '5px' }}>
                                <Col sm='3'>
                                    <FormGroup>
                                        <Label for={`property-name-${index}`}>Property Name</Label>
                                        <Input
                                            id={`property-name-${index}`}
                                            name="property-name"
                                            type="text"
                                            placeholder="Enter property name"
                                            value={property.name}
                                            onChange={(e) => handlePropertyChange(index, 'name', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm='3'>
                                    <FormGroup>
                                        <Label for={`property-address-${index}`}>Property Address</Label>
                                        <Input
                                            id={`property-address-${index}`}
                                            name="property-address"
                                            type="text"
                                            placeholder="e.g. 5"
                                            value={property.address}
                                            onChange={(e) => handlePropertyChange(index, 'address', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm='3'>
                                    <FormGroup>
                                        <Label for={`contact-name-${index}`}>Contact Name</Label>
                                        <Input
                                            id={`contact-name-${index}`}
                                            name="contact-name"
                                            type="text"
                                            placeholder="Enter contact name"
                                            value={property.contact_name}
                                            onChange={(e) => handlePropertyChange(index, 'contact_name', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={index > 0 ? '2' : '3'}>
                                    <FormGroup>
                                        <Label for={`contact-email-${index}`}>Contact Email</Label>
                                        <Input
                                            id={`contact-email-${index}`}
                                            name="contact-email"
                                            type="email"
                                            placeholder="Enter contact email"
                                            value={property.contact_email}
                                            onChange={(e) => handlePropertyChange(index, 'contact_email', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm='1' className="d-flex align-items-center justify-center">
                                    {index > 0 && (
                                        <Trash2
                                            size={20}
                                            color="red"
                                            style={{ cursor: 'pointer', marginBottom: '20px' }}
                                            onClick={() => removePropertyRow(index)}
                                        />
                                    )}
                                </Col>
                            </Row>
                        ))}
                        <Row>
                            <Col sm="1">
                                <Btn color='info' onClick={addPropertyRow}>
                                    <Plus size={28} color='white' />
                                </Btn>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
                <Modal isOpen={editClientModalOpen} toggle={toggleEditClientModal} action={handleEditClient} title="Edit Client" button='Update' size='md'>
                    <Form>
                        <Row>
                            <Col sm='6'>
                                <FormGroup>
                                    <Label for="client-name">Client Name</Label>
                                    <Input
                                        id="client-name"
                                        name="client-name"
                                        type="text"
                                        placeholder="Enter client name"
                                        value={editName}
                                        onChange={(e) => setEditName(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='6'>
                                <FormGroup>
                                    <Label for="client-email">Client Email</Label>
                                    <Input
                                        id="client-email"
                                        name="client-email"
                                        type="email"
                                        placeholder="Enter client email"
                                        value={editEmail}
                                        onChange={(e) => setEditEmail(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='6'>
                                <FormGroup>
                                    <SelectDropdown title={'Country'} options={countryOptions} onOptionSelected={(val) => handleEditCountryChange(val)} value={editCountry} />
                                </FormGroup>
                            </Col>
                            <Col sm='6'>
                                <FormGroup>
                                    <Label for="client-address">Client Address</Label>
                                    <Input
                                        id="client-address"
                                        name="client-address"
                                        type="textarea"
                                        placeholder="Enter client address"
                                        value={editAddress}
                                        onChange={(e) => setEditAddress(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        {/* <Row style={{ marginTop: '5px' }}>
                            <Col sm='4'>Properties</Col>
                        </Row>
                        {editProperties.map((property, index) => (
                            <Row key={index} style={{ marginTop: '5px' }}>
                                <Col sm='3'>
                                    <FormGroup>
                                        <Label for={`property-name-${index}`}>Property Name</Label>
                                        <Input
                                            id={`property-name-${index}`}
                                            name="property-name"
                                            type="text"
                                            placeholder="Enter property name"
                                            value={property.name}
                                            onChange={(e) => handleEditPropertyChange(index, 'name', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm='3'>
                                    <FormGroup>
                                        <Label for={`property-address-${index}`}>Property Address</Label>
                                        <Input
                                            id={`property-address-${index}`}
                                            name="property-address"
                                            type="text"
                                            placeholder="e.g. 5"
                                            value={property.address}
                                            onChange={(e) => handleEditPropertyChange(index, 'address', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm='3'>
                                    <FormGroup>
                                        <Label for={`contact-name-${index}`}>Contact Name</Label>
                                        <Input
                                            id={`contact-name-${index}`}
                                            name="contact-name"
                                            type="text"
                                            placeholder="Enter contact name"
                                            value={property.contact_name}
                                            onChange={(e) => handleEditPropertyChange(index, 'contact_name', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={index > 0 ? '2' : '3'}>
                                    <FormGroup>
                                        <Label for={`contact-email-${index}`}>Contact Email</Label>
                                        <Input
                                            id={`contact-email-${index}`}
                                            name="contact-email"
                                            type="email"
                                            placeholder="Enter contact email"
                                            value={property.contact_email}
                                            onChange={(e) => handleEditPropertyChange(index, 'contact_email', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm='1' className="d-flex align-items-center justify-center">
                                    {index > 0 && (
                                        <Trash2
                                            size={20}
                                            color="red"
                                            style={{ cursor: 'pointer', marginBottom: '20px' }}
                                            onClick={() => removeEditPropertyRow(index)}
                                        />
                                    )}
                                </Col>
                            </Row>
                        ))}
                        <Row>
                            <Col sm="1">
                                <Btn color='info' onClick={addEditPropertyRow}>
                                    <Plus size={28} color='white' />
                                </Btn>
                            </Col>
                        </Row> */}
                    </Form>
                </Modal>
            </Container>
        </>
    );
}